<div class="modal-header modal-block-primary">
  <button type="button" class="close" (click)="modalRef.hide()">
    <span aria-hidden="true">&times;</span>
    <span class="sr-only">Close</span>
  </button>
  <h4 class="modal-title">Select a claim to match</h4>
</div>
<div class="modal-body">
  <app-grid-wrapper #remittanceClaimLinesGrid [autoHeight]="false"></app-grid-wrapper>
</div>
<div class="modal-footer">
  <button class="btn btn-primary" [disabled]="!hasSelection" (click)="matchClaim(true)">
    Match
  </button>
  <button class="btn btn-default" (click)="matchClaim(false)">Cancel</button>
</div>
